/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { AppState } from 'amo/store';
import { getPromotedBadgesLinkUrl } from 'amo/utils/promoted';
import {
  ADDON_TYPE_EXTENSION,
  EXCLUDE_WARNING_CATEGORIES,
} from 'amo/constants';
import translate from 'amo/i18n/translate';
import { getPromotedCategory } from 'amo/utils/addons';
import { isFirefox } from 'amo/utils/compatibility';
import Notice, { genericWarningType } from 'amo/components/Notice';
import type { UserAgentInfoType } from 'amo/reducers/api';
import type { AddonType } from 'amo/types/addons';
import type { I18nType } from 'amo/types/i18n';

import './styles.scss';

type Props = {|
  addon: AddonType,
|};

type PropsFromState = {|
  clientApp: string,
  userAgentInfo: UserAgentInfoType,
|};

type DefaultProps = {|
  _getPromotedCategory: typeof getPromotedCategory,
|};

type InternalProps = {|
  ...Props,
  ...PropsFromState,
  ...DefaultProps,
  i18n: I18nType,
|};

export const VARIANT_INCLUDE_WARNING_PROPOSED = 'includeWarning-proposed';
const WARNING_LINK_DESTINATION = getPromotedBadgesLinkUrl({
  utm_content: 'install-warning',
});

export class InstallWarningBase extends React.Component<InternalProps> {
  static defaultProps: DefaultProps = {
    _getPromotedCategory: getPromotedCategory,
  };

  couldShowWarning: () => boolean = () => {
    const { _getPromotedCategory, addon, clientApp, userAgentInfo } =
      this.props;

    const promotedCategory = _getPromotedCategory({
      addon,
      clientApp,
    });

    return (
      isFirefox({ userAgentInfo }) &&
      addon.type === ADDON_TYPE_EXTENSION &&
      (!promotedCategory ||
        !EXCLUDE_WARNING_CATEGORIES.includes(promotedCategory))
    );
  };

  render(): null | React.Node {
    const { i18n } = this.props;

    if (this.couldShowWarning()) {
      return (
        <Notice
          actionHref={WARNING_LINK_DESTINATION}
          actionTarget="_blank"
          actionText={i18n.gettext('Learn more')}
          className="InstallWarning"
          type={genericWarningType}
        >
          {i18n.gettext(
            'This add-on is not actively monitored for security by Mozilla. Make sure you trust it before installing.',
          )}
        </Notice>
      );
    }
    return null;
  }
}

const mapStateToProps = (state: AppState): PropsFromState => {
  return {
    clientApp: state.api.clientApp,
    userAgentInfo: state.api.userAgentInfo,
  };
};

const InstallWarning: React.ComponentType<Props> = compose(
  connect(mapStateToProps),
  translate(),
)(InstallWarningBase);

export default InstallWarning;
